import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AccountDisabled() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleExit = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="section-padding mx-auto w-full max-w-lg">
        <div className="card space-y-4 p-6">
          <h1 className="page-title text-2xl">Account disabled</h1>
          <p className="text-sm text-slate-600">
            Your account is currently disabled. Please contact support to regain
            access.
          </p>
          <button className="btn btn-primary w-full" onClick={handleExit}>
            Return to login
          </button>
        </div>
      </section>
    </div>
  );
}
